"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryApi = void 0;
var HistoryApi = (function () {
    function HistoryApi(core) {
        this._core = core;
    }
    HistoryApi.prototype.beginTransaction = function () {
        this._core.modelManager.history.beginTransaction();
    };
    HistoryApi.prototype.endTransaction = function () {
        this._core.modelManager.history.endTransaction();
    };
    HistoryApi.prototype.redo = function () {
        this._core.modelManager.history.redo();
    };
    HistoryApi.prototype.undo = function () {
        this._core.modelManager.history.undo();
    };
    HistoryApi.prototype.clear = function () {
        this._core.modelManager.history.clear();
        this._core.barHolder.updateItemsState();
    };
    return HistoryApi;
}());
exports.HistoryApi = HistoryApi;
